import classNames from 'classnames'
import styles from './BaseModalHeader.module.scss'
import type { BaseModalHeaderProps } from './types'

const BaseModalHeader = ({ className, children }: BaseModalHeaderProps) => {
  return (
    <div className={classNames(styles['pintxo-modal__header'], className)}>
      {<div className={styles['pintxo-modal__header__slot']}>{children}</div>}
    </div>
  )
}
export default BaseModalHeader
